<template>
    <svg id="headset" height="20.835" viewBox="0 0 20.835 20.835" width="20.835" xmlns="http://www.w3.org/2000/svg">
        <g id="Group_2592" data-name="Group 2592" transform="translate(0 0)">
            <g id="Group_2591" data-name="Group 2591">
                <path
                    id="Path_2236"
                    d="M4.883,8.261H3.275A7.163,7.163,0,0,1,17.137,6.3a.814.814,0,0,0,1.527-.565A8.791,8.791,0,0,0,1.629,8.7,3.257,3.257,0,0,0,0,11.516v2.767a3.259,3.259,0,0,0,3.255,3.255H4.883a.814.814,0,0,0,.814-.814V9.075A.814.814,0,0,0,4.883,8.261Zm-.814,7.65H3.255a1.63,1.63,0,0,1-1.628-1.628V11.516A1.63,1.63,0,0,1,3.255,9.888h.814Z"
                    data-name="Path 2236"
                    fill="#afafaf"
                    transform="translate(0 0)"
                />
                <path
                    id="Path_2237"
                    d="M224.79,203h-1.628a.814.814,0,0,0-.814.814v8.5a.815.815,0,0,1-.814.814h-2.482v.026a1.628,1.628,0,1,0,0,1.576v.026h2.482a2.444,2.444,0,0,0,2.442-2.442v-.041h.814a3.259,3.259,0,0,0,3.255-3.255v-2.767A3.259,3.259,0,0,0,224.79,203Zm1.628,6.023a1.63,1.63,0,0,1-1.628,1.628h-.814v-6.023h.814a1.63,1.63,0,0,1,1.628,1.628Z"
                    data-name="Path 2237"
                    fill="#afafaf"
                    transform="translate(-207.21 -194.739)"
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "AssignRepresentative",
};
</script>
